export default "__VITE_PUBLIC_ASSET__8b1a0d84__"